<template>
  <div class="insight-feedback">
    <template v-if="!answered">
      <div class="title">זה עזר לך?</div>
      <div class="thumbs">
        <riseup-button class="thumbs-up" variant="secondary" :action="thumbsUp" :icon="require('@/assets/icons/thumbs-up.svg')"/>
        <riseup-button class="thumbs-down" variant="secondary" :action="thumbsDown" :icon="require('@/assets/icons/thumbs-down.svg')"/>
      </div>
    </template>
    <template v-else>
      <div class="title">תודה!</div>
      <div class="sub-title">זה יעזור לנו להראות לך רק מה שמעניין אותך</div>
    </template>
  </div>
</template>

<script>
import '@lottiefiles/lottie-player';
import BaseUI from 'base-ui';

export default {
  name: 'InsightFeedback',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  data() {
    return {
      answered: false,
    };
  },
  computed: {
    buttons() {
      return [
        {
          title: 'סגור',
          variant: 'primary',
          action: this.closeActionClicked,
        },
      ];
    },
  },
  methods: {
    thumbsUp() {
      this.$emit('thumbs-up');
      this.answered = true;
    },
    thumbsDown() {
      this.$emit('thumbs-down');
      this.answered = true;
    },
  },
};

</script>

<style scoped lang="scss">

  @import "~base-ui/src/scss/riseup-colors";

  .insight-feedback {
    font-family: SimplerPro;

    .title {
      font-family: SimplerPro;
      text-align: center;
      font-size: 22px;
      font-weight: bold;
      margin: 10px 0 20px 0;
    }
    .thumbs {
      margin: 20px 0;
      display: flex;
      width: 100%;
      justify-content: space-between;
      button {
        width: 45%;
      }
    }
    .sub-title {
      margin-bottom: 20px;
      text-align: center;
      font-size: 22px;
    }
  }

</style>
